angular.module('invoice')
    .component('invoiceCostCenterList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/invoice/cost-center/list.html',
        controller: function ($scope, $httpParamSerializer, $state, $stateParams, InvoiceCostCenterService, InvoiceService, Principal) {
            this.reset = () => this.filters = {}
            this.InvoiceService = InvoiceService
            this.InvoiceCostCenterService = InvoiceCostCenterService

            this.$onInit = () => {
                this.canEdit = Principal.hasAnyAuthority(['ROLE_INVOICE_SETTINGS_WRITE'])
            }

            this.getExportUrl = (params) => {
                let paramsAll = angular.copy($stateParams);
                angular.extend(paramsAll, params);
                return "/crm/api/invoice-cost-center-batch/export?" + $httpParamSerializer(paramsAll)
            }

            $scope.$on('invoice-cost-center.updated', () => $state.reload())
        }
    })
